// Firebase configuration and initialization
// This file provides direct access to Firebase services without circular dependencies

import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, memoryLocalCache, getFirestore, type Firestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

// Firebase configuration from environment variables
const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDRgjzNc68b0mGADlPn3vuMk1lN-ffxjxI",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "intouch-d6f00.firebaseapp.com",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://intouch-d6f00-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "intouch-d6f00",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "intouch-d6f00.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "406176284498",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:406176284498:web:ad5b11c2e17a7f3c3f76c7"
};

// Initialize Firebase app (singleton pattern)
const app = !getApps().length ? initializeApp(FIREBASE_CONFIG) : getApp();

// Initialize Firestore once with resilient network transport and offline cache.
let db: Firestore;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager()
    }),
    experimentalForceLongPolling: true,
  });
} catch {
  try {
    db = getFirestore(app);
  } catch (error) {
    // Fallback to memory cache for environments where persistence is blocked.
    db = initializeFirestore(app, {
      localCache: memoryLocalCache(),
      experimentalForceLongPolling: true,
    });
  }
}

// Initialize other services
const auth = getAuth(app);
const rtdb = getDatabase(app);
const storage = getStorage(app);

export { app, auth, db, rtdb, storage };
export default app;
